const calcTextHeight = list => {
  let res = 0
  list.forEach(item => {
    const height = item.offsetHeight
    const marginBottom = window.getComputedStyle(item).marginBottom
    res += height
    res += parseInt(marginBottom)
  })
  return res
}

const calcedCards = document.querySelectorAll('.service-card_with-img, .industry-card')
calcedCards.forEach(card => {
  const textEl = card.querySelector('.service-card__text') || card.querySelector('.industry-card__text')

  card.addEventListener('mouseenter', () => {
    const isHover = window.matchMedia('(hover: hover)').matches

    if (isHover) {
      if (textEl) {
				const calcedHeight = calcTextHeight(Array.from(textEl.children))
				const textElStyle = window.getComputedStyle(textEl)

        card.style.setProperty('--card-text-height', `${calcedHeight + parseInt(textElStyle.marginTop) + parseInt(textElStyle.marginBottom)}px`)
      }
    }
  })
})
